/** @file attachmentGroups: the weapon groups a puppet's flattened attachments can be switched between. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** The distinct `weaponGroup`s of `puppet.attachments`, in order of first appearance ([] without attachments). */
export function attachmentGroups(puppet: Pick<Puppet, 'attachments'>): string[] {
  return [...new Set((puppet.attachments ?? []).flatMap((a) => (a.weaponGroup === undefined ? [] : [a.weaponGroup])))];
}
